<template>
   <InputNumber
      style="width: 8rem"
      v-model="model"
      input-id="horizontal-buttons"
      show-buttons
      size="small"
      button-layout="horizontal"
      :step="1"
      :min="1"
      :max="10"
      fluid
   >
      <template #incrementbuttonicon>
         <span class="pi pi-plus" />
      </template>
      <template #decrementbuttonicon>
         <span class="pi pi-minus" />
      </template>
   </InputNumber>
   <slot
      v-if="model === max"
      name="max-text"
   />
   <slot name="help-text" />
</template>

<script setup>
   import { InputNumber } from 'primevue';

   const model = defineModel({
      type: Number,
      required: true,
   });

   const props = defineProps({
      min: {
         type: Number,
         default: 1,
      },
      max: Number,
   });
</script>

<style scoped></style>
